// extracted by mini-css-extract-plugin
export default {"linkedin_icon":"Team_linkedin_icon__SdDXz","email_icon":"Team_email_icon__ILEbf","title":"Team_title__8Q432","horizontal_stack":"Team_horizontal_stack__cNNjO"};